import React from "react";

import { IHistoryItemProps } from "./types";
import styles from "./HistoryItem.module.scss";

const HistoryItem: React.FC<IHistoryItemProps> = (props) => {
	const { data } = props;
	const isCourt = data.type === 'Корт';
	const isRacket = !!data.productId && !data.courtId;
	const hasBoth = !!data.productId && !!data.courtId;

	const formatTime = (dateString: string) => {
		const timePart = dateString.split('T')[1];
		if (!timePart) return '';
		const [hours, minutes] = timePart.split(':');
		return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
	};

	// paidAt приходит из нашей БД в UTC — показываем по Москве, как и всё остальное.
	const formatPaidAt = (iso: string) => {
		const date = new Date(iso);
		if (isNaN(date.getTime())) return '';
		return date.toLocaleString('ru-RU', {
			timeZone: 'Europe/Moscow',
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		});
	};

	const renderRow = (isRacketRow: boolean) => (
		<div className={styles.infoRow}>
			<div className={styles.leftSide}>
				<span className={styles.courtName}>
					{isRacketRow ? 'Ракетка' : data.courtName}
				</span>
				<span className={styles.subtitle}>
					{isRacketRow
						? `Кол-во: ${data.productQuantity}`
						: 'Продолжительность: 1 час'
					}
				</span>
			</div>
			<div className={styles.rightSide}>
				<span className={styles.timeRange}>
					{formatTime(data.timeStart)} - {formatTime(data.finishTime)}
				</span>
				<span className={styles.price}>
					{isRacketRow ? data.productSum : data.rentSum} руб.
				</span>
			</div>
		</div>
	);

	return (
		<div className={styles.card}>
			{renderRow(isRacket)}
			{hasBoth && (
				<div className={styles.separator}>
					{renderRow(true)}
				</div>
			)}
			{data.paidAt && (
				<span className={styles.paidAt}>
					Оплачено: {formatPaidAt(data.paidAt)}
				</span>
			)}
		</div>
	);
}

export default HistoryItem;
